var AppModule = (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
